import React, { useEffect, useState } from "react";
import { isEmpty, isNil, map, concat, sortBy, isArray } from 'lodash';
import { Avatar as AntAvatar, Collapse, Drawer } from 'antd';
import { Space } from 'antd';
import { MenuOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from '@life-line-lab/components-react';
import './navbar.scss';
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { authPassportAtom } from "Recoil/auth.atom";
import { authLogout } from "Services/auth.services";
import { LanguageSelector } from '@life-line-lab/components-react';
import { useRefreshLanguageSettingState } from "Hooks/language-setting.hook";

const HamburgerNav = ({ isAuth, menus, footers, location }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false)
  const onClose = () => {
    setOpen(false);
  }
  const [languageSetting, ] = useRefreshLanguageSettingState();

  const { t, i18n } = useTranslation();
  const [authPassport, setAuthPassport] = useRecoilState<any>(authPassportAtom);
  const reactRouterLocation = useLocation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem("i18next", value);
    window.location.reload();
  }


  const languageOptions = [
    {
      label: 'English',
      initial: 'EN',
      value: 'en',
    },
    {
      label: 'Bahasa Melayu',
      initial: 'BM',
      value: 'ms',
    }
  ];

  // if user does not have i18n language in localStorage, set the default language, if is different from the app.
  useEffect(() => {
    const currentLanguage = localStorage.getItem('i18next');
    if (currentLanguage) return;

    if (!languageSetting) return;

    const foundEcomLanguageObj = languageSetting.languageSetting.find(s => s.site === process.env.ACCOUNT_TYPE);
    if (foundEcomLanguageObj) {
      const foundI18NLanguage = languageOptions.find(m => m.initial === foundEcomLanguageObj.defaultLanguage);
      if (foundI18NLanguage && foundI18NLanguage.value !== i18n.language) {
        handleLanguageChange(foundI18NLanguage.value);
      }
    }
  }, [languageSetting])

  const hamburgerIcon = (
    <AntAvatar
      style={{ background: 'transparent' }}
      icon={
        <MenuOutlined
          className="mobile icon svg"
          style={{ color: '#442f84', width: '70%', height: '70%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          onClick={() => setOpen(!open)}
        />}
    />
  )

  const profileMenus: any[] = [
    {
      label: t('pageTitle.account'),
      position: -1,
      children: [
        {
          label: t('nav.profile'),
          href: '/profile'
        },
        {
          label: t('nav.myPurchase'),
          href: '/purchase'
        },
      ]
    },
  ];

  const logoutMenu = [
    {
      label: t('nav.logout'),
      position: 6,
      callFunction: () => {
        authLogout();
        setAuthPassport({});
      }
    },
  ]

  const menuList = isAuth ?
    concat(profileMenus, menus, footers, logoutMenu) :
    concat(menus, footers);

  return (
    <div className="mobile-menu">
      {hamburgerIcon}
      {open &&
        <Drawer
          className="mobile-menu"
          title="Menu"
          placement="right"
          onClose={onClose}
          visible={open}
        >

          {map(sortBy(menuList, 'position'), (menu, index) => {
            if (!isEmpty(menu.children)) {
              return (
                <React.Fragment key={index}>
                  <Collapse
                    ghost={true}
                    expandIconPosition="right"
                    expandIcon={({ isActive }) => <PlusOutlined rotate={isActive ? 90 : 0} />}
                  >
                    <Collapse.Panel
                      key={index}
                      header={
                        <React.Fragment>
                          <span
                            className="label"
                            onClick={() => {
                              if (menu.href) {
                                history.push(menu.href)
                              } else if (menu.fullHypertextRef) {
                                location.href = menu.fullHypertextRef
                              } else if (menu.callFunction) {
                                menu.callFunction();
                              }
                            }}
                          >
                            {menu.label}
                          </span>
                        </React.Fragment>
                      }
                    >
                      <ul>
                        {menu.children.map((subItem: any, subItemKey: number | string) => {
                          return (
                            <li key={`${index}.${subItemKey}`}>
                              <span
                                className="label sub-label"
                                onClick={() => {
                                  if (subItem.href) {
                                    history.push(subItem.href)
                                  } else if (subItem.fullHypertextRef) {
                                    window.location.href = subItem.fullHypertextRef
                                  } else if (subItem.callFunction) {
                                    subItem.callFunction();
                                  }
                                }}
                              >
                                {subItem.label}
                              </span>
                            </li>
                          )
                        })}
                      </ul>
                    </Collapse.Panel>
                  </Collapse>
                </React.Fragment>
              )
            }
            else {
              if (menu.isLang) {
                return (
                  <Space direction="horizontal" size="small">
                    <LanguageSelector
                      mode="long"
                      currentLanguage={i18n.language}
                      options={languageOptions}
                      onChange={handleLanguageChange}
                    />
                  </Space>
                )
              }
              else {
                if (menu.isButton) {
                  return (
                    <div key={index} className="no-child" style={{ padding: '7px 0' }}>
                      {!isAuth &&
                        <div className="navButtons" style={{ padding: '5px 20px' }}>
                          {location.pathname !== (menu.location) &&
                            <Button type={menu.type}
                              label={menu.label}
                              onClick={() => {
                                if (menu.href) {
                                  history.push(menu.href)
                                } else if (menu.fullHypertextRef) {
                                  window.location.href = menu.fullHypertextRef
                                }
                              }}
                            />}
                        </div>
                      }
                    </div>
                  )
                } else if (menu.customComponent) {
                  return (
                    <div key={index}>
                      {
                        (menu.hideIfLoggedIn && isAuth) ||
                          (isArray(menu.hideOnPath) && menu.hideOnPath.includes(reactRouterLocation.pathname)) ?
                          null :
                          menu.customComponent
                      }
                    </div>
                  )
                } else {
                  return (
                    <div key={index} className="no-child" style={{ padding: '7px 0' }}>
                      <span
                        className="label"
                        onClick={() => {
                          if (menu.href) {
                            history.push(menu.href)
                          } else if (menu.fullHypertextRef) {
                            window.location.href = menu.fullHypertextRef
                          } else if (menu.callFunction) {
                            menu.callFunction();
                          }
                        }}
                      >
                        {menu.label}
                      </span>
                    </div>
                  )
                }
              }
            }})}

        </Drawer>}
    </div>
  )
}


export default HamburgerNav